export default {
  updateEmailSignature: (state, emailSignature) => {
    const index = state.emailSignatures.findIndex(es => es._id === emailSignature._id);
    if (index >= 0) {
      state.emailSignatures.splice(index, 1, emailSignature);
    } else {
      state.emailSignatures.push(emailSignature);
    }
    state.selectedEmailSignature = emailSignature;
  },
  setEmailSignatures: (state, emailSignatures) => {
    state.emailSignatures = emailSignatures;
    state.selectedEmailSignature = emailSignatures[0];
  },
  setSelectedEmailSignature: (state, id) => {
    const emailSignature = state.emailSignatures.find(es => es._id === id);
    state.selectedEmailSignature = emailSignature;
  },
  setOverwriteEmailSignature: (state, emailSignature) => {
    const index = state.emailSignatures.findIndex(es => es._id === emailSignature._id);
    if (index >= 0) {
      state.emailSignatures.splice(index, 1, emailSignature);
    }
  }
};
